function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table as BTable } from "react-bootstrap";
import { Divider, Skeleton, Button, Modal, Space, Spin, Alert, Switch, Tabs, notification, Drawer, Statistic, Card, Tag, Table, Breadcrumb } from 'antd';
import Common from "../components/includes/Common";
import { TrashFill, PencilSquare, Plug, BoxArrowInRight, BoxFill, MapFill, CartCheckFill, ClockHistory, Truck, Activity, ClockFill, PersonFill, CheckCircleFill, KeyFill, CashCoin, Plus, ExclamationCircleFill, PeopleFill, XCircleFill } from 'react-bootstrap-icons';
import EditUser from "../components/forms/EditUser";
import EditUserPassword from "../components/forms/EditUserPassword";
import ProvideItemsToAgent from "../components/forms/ProvideItemsToAgent";
import AddAgent from "../components/forms/AddAgent";
import SalesHistory from "../components/SalesHistory";
import AbortSales from "../components/AbortSales";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Delivery = function Delivery() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    summary = _useState4[0],
    setSummary = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewUserCreated = _useState6[0],
    setIsNewUserCreated = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataUpdated = _useState0[0],
    setIsDataUpdated = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isProcessing = _useState10[0],
    setIsProcessing = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    operationSuccessMessage = _useState12[0],
    setOperationSuccessMessage = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    operationErroMessage = _useState14[0],
    setOperationErrorMessage = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isUserEditVisible = _useState16[0],
    setIsUserEditVisible = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showProvide = _useState18[0],
    setShowProvide = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showNewAgent = _useState20[0],
    setShowNewAgent = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    operationalData = _useState22[0],
    setOperationalData = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    ltsDeliveriesData = _useState24[0],
    setLtsDeliveriesData = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    upcommingDeliveriesData = _useState26[0],
    setUpcommingDeliveriesData = _useState26[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Agent"
    }),
    dataIndex: "agent",
    render: function render(v) {
      return /*#__PURE__*/_jsx("b", {
        children: v
      });
    },
    key: "agent"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Status"
    }),
    dataIndex: "status",
    render: function render(status) {
      return /*#__PURE__*/_jsx(Space, {
        children: status == 0 ? /*#__PURE__*/_jsx(Tag, {
          color: "error",
          icon: /*#__PURE__*/_jsx(XCircleFill, {})
        }) : /*#__PURE__*/_jsx(Tag, {
          color: "success",
          icon: /*#__PURE__*/_jsx(CheckCircleFill, {})
        })
      });
    },
    key: "status"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Livraisons (7j)"
    }),
    dataIndex: "delivery_count_7d",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "delivery_count_7d"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE8rni\xE8re activit\xE9 (7j)"
    }),
    dataIndex: "last_activity",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "last_activity"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: 'user',
    key: "user",
    render: function render(u) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Switch, {
          onChange: function onChange(checked) {
            switchStatus(u, checked);
          },
          size: "default",
          checked: u.status == 1
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            handleEdit(u);
          },
          children: /*#__PURE__*/_jsx(PencilSquare, {
            size: 18
          })
        })]
      });
    }
  }];
  var ltsDeliveriesCol = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Commande"
    }),
    dataIndex: "order",
    key: "order",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Client"
    }),
    dataIndex: "customer",
    key: "customer",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Agent"
    }),
    dataIndex: "driver",
    key: "driver",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: "date",
    key: "date",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v && /*#__PURE__*/_jsx(Moment, {
          date: v,
          format: "DD/MM/YYYY"
        })
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Bouteilles/Articles"
    }),
    dataIndex: "sellableCount",
    key: "sellableCount",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }];
  var upcomingDeliveriesCol = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Agent"
    }),
    dataIndex: "driver",
    key: "driver",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Temps restant"
    }),
    dataIndex: "time",
    key: "time",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v && /*#__PURE__*/_jsx(Moment, {
          date: v,
          format: "DD/MM/YYYY"
        })
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Adresse"
    }),
    dataIndex: "address",
    key: "address",
    render: function render(v) {
      return /*#__PURE__*/_jsx("span", {
        children: v
      });
    }
  }];
  var todayDeliveriesSummaryCols = [{
    dataIndex: "caption",
    key: "cation",
    render: function render(v) {
      return /*#__PURE__*/_jsx("div", {
        children: v
      });
    }
  }, {
    dataIndex: "value",
    key: "value",
    render: function render(v) {
      return /*#__PURE__*/_jsx("div", {
        children: v
      });
    }
  }];
  var handleDelete = function handleDelete(u) {
    setSelectedUser(u);
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: 'La supression de ' + u.prenom + '?',
      onOk: function onOk() {
        setIsProcessing(true);
        axios.post(Common.baseApiUrl + 'deleteuser', {
          id: u.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          setIsProcessing(false);
          if (response.data.status == 200) {
            setOperationSuccessMessage(response.data.message);
            setIsDataUpdated(true);
          } else {
            setOperationErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setIsProcessing(false);
          setOperationErrorMessage(response.data.message);
        }).then(function () {
          setIsDataUpdated(false);
        });
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var handleEdit = function handleEdit(u) {
    setSelectedUser(u);
    setIsUserEditVisible(true);
  };
  var switchStatus = function switchStatus(checked, u) {
    var action = checked == false ? 'Bloquage' : 'Débloquage';
    axios.post(Common.baseApiUrl + 'witchusertatus', {
      current: u.status,
      aid: Common.currentUser.id,
      uid: u.id
    }).then(function (response) {
      if (response.data.status == 200) {
        //setIsDataUpdated(true);  
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: 'Une erreur est survenue'
      });
    });
  };
  useEffect(function () {
    setIsNewUserCreated(false);
    setIsDataUpdated(false);
    axios.all([axios.get(Common.baseApiUrl + 'getoperationaldata/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getagentssummary/' + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setOperationalData({
          activeDriverCount: response[0].data.activeDriverCount,
          totalDayDeliveriesCount: response[0].data.totalDayDeliveriesCount,
          onTimeRate: response[0].data.onTimeRate,
          pendingDeliveriesCount: response[0].data.pendingDeliveriesCount,
          terminatedDeliveriesCount: response[0].data.terminatedDeliveriesCount,
          lateDeliveriesCount: response[0].data.lateDeliveriesCount
        });
        setLtsDeliveriesData([]);
        response[0].data.latestTerminatedDeliveries.forEach(function (o) {
          setLtsDeliveriesData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              order: "CMD-00" + o.id.toString(),
              customer: o.customer && o.customer.name,
              driver: o.delivery_user && o.delivery_user.prenom + " " + o.delivery_user.nom,
              date: o.delivered_at,
              sellableCount: o.purchase_order_items && o.purchase_order_items.length
            }]);
          });
        });
        response[0].data.nextDeliveries.forEach(function (o) {
          setUpcommingDeliveriesData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              driver: o.delivery_user && o.delivery_user.prenom + " " + o.delivery_user.nom,
              time: o.created_at,
              address: o.customer && o.customer.address
            }]);
          });
        });
      } else {}
      if (response[1].data.status == 200) {
        setSummary([]);
        response[1].data.summary.forEach(function (u) {
          setSummary(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              agent: u.prenom + " " + u.nom,
              status: u.status,
              delivery_count_7d: u.deliveries_last_7_days,
              last_activity: u.last_activity,
              user: u
            }]);
          });
        });
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isNewUserCreated, isDataUpdated]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ContextHolder, operationalData && summary ? /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Breadcrumb, {
            items: [{
              title: /*#__PURE__*/_jsx("span", {
                children: "LIVRAISONS"
              })
            }, {
              title: "Résumé"
            }]
          }), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Agents actifs",
              value: operationalData.activeDriverCount,
              suffix: "/" + summary.length,
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(SportsModeIcon, {
                height: "26px"
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Total livraisons aujourdh'ui",
              value: operationalData.totalDayDeliveriesCount,
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(Truck, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Livraisons en attente",
              value: operationalData.pendingDeliveriesCount,
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(ClockHistory, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Taux de livraison \xE0 temps",
              value: operationalData.onTimeRate,
              suffix: "%",
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(ClockFill, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#EC742C"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: /*#__PURE__*/_jsx("div", {
            className: "al-card",
            style: {
              minHeight: "300px"
            },
            children: isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Table, {
                dataSource: summary,
                columns: cols,
                stripped: true,
                bordered: true
              })
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            className: "al-card",
            children: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(MapFill, {
                size: 20
              }), " Suivi des livraisons"]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsxs(Card, {
            variant: "borderless",
            children: [/*#__PURE__*/_jsx("h6", {
              children: "Livraisons aujourd'hui"
            }), /*#__PURE__*/_jsx(Space, {
              direction: "vertical",
              children: /*#__PURE__*/_jsx(Table, {
                pagination: false,
                showHeader: false,
                columns: todayDeliveriesSummaryCols,
                dataSource: [{
                  caption: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(Truck, {
                      size: 20
                    }), " En cours"]
                  }),
                  value: operationalData.pendingDeliveriesCount
                }, {
                  caption: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(CheckCircleFill, {
                      size: 20
                    }), " Termin\xE9es"]
                  }),
                  value: operationalData.terminatedDeliveriesCount
                }, {
                  caption: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(ClockHistory, {
                      size: 20
                    }), " En retard (Non livr\xE9es)"]
                  }),
                  value: operationalData.lateDeliveriesCount
                }]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs(Card, {
            variant: "borderless",
            children: [/*#__PURE__*/_jsx("h6", {
              children: "Livraisons recentes"
            }), /*#__PURE__*/_jsx(Table, {
              showHeader: false,
              dateSource: ltsDeliveriesData,
              bordered: true,
              coloumns: ltsDeliveriesCol
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsxs(Card, {
            variant: "borderless",
            children: [/*#__PURE__*/_jsx("h6", {
              children: "Prochaines livraisons"
            }), /*#__PURE__*/_jsx(Table, {
              showHeader: false,
              dateSource: upcommingDeliveriesData,
              bordered: true,
              coloumns: upcomingDeliveriesCol
            })]
          })
        })]
      })]
    }) : /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Skeleton, {
            active: true
          })
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Nouveau"
      }),
      open: showNewAgent,
      onCancel: function onCancel() {
        setShowNewAgent(false);
      },
      destroyOnClose: true,
      footer: null,
      width: {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddAgent, {
        handler: function handler() {
          setIsDataUpdated(true);
          setShowNewAgent(false);
          notification.success({
            message: "Ok!",
            description: "Opération enrégistrée"
          });
        }
      })
    })]
  });
};
export default Delivery;